import i18next from "i18next";

export const formatWithCurrency = (amount, selectedCurrency, formatter, amountFormat) => {
    if (selectedCurrency) {
      const currencyCode = selectedCurrency.currency_code?.trim() || 'SAR';
      
      const customFormatter = new Intl.NumberFormat(i18next.language, {
        style: 'currency',
        currency: currencyCode.toUpperCase()
      });
      
      return customFormatter.format(amountFormat(amount || 0));
    }
    
    // Fall back to the default formatter
    return formatter.format(amountFormat(amount || 0));
  };